import {
  GlobalDesignActionType,
  GlobalDesignGroupAction,
  ComparisonMode,
} from '../types';
import { strokeGrouping } from './grouping';
import StrokeStyles from './StrokeStyles';
import StrokeLobbyItem from './StrokeLobbyItem';
import { strokeGroupDisplayFilter } from './groupDisplayFilter';

const strokeAction: GlobalDesignGroupAction = {
  type: GlobalDesignActionType.Group,
  panel: StrokeStyles,
  lobbyItem: StrokeLobbyItem,
  comparisonMode: ComparisonMode.DirectProps,
  grouping: strokeGrouping,
  groupDisplayFilter: strokeGroupDisplayFilter,
};

export default strokeAction;
